
import React from 'react';

export const HeroSection: React.FC = () => {
  return (
    <section className="bg-gradient-to-r from-[#f4fbf7] to-white py-12 sm:py-16 lg:py-20">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="text-center mb-8 sm:mb-12">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-brand-primary mb-4 sm:mb-6">
            Nossos Consultórios
          </h1>
          <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-4xl mx-auto">
            Escolha o local mais conveniente para você. Atendimento de qualidade em três localizações estratégicas
          </p>
          <div className="mt-6 sm:mt-8 flex flex-wrap justify-center gap-3 sm:gap-4 text-xs sm:text-sm text-gray-600">
            <span className="bg-white border border-gray-100 px-4 py-2 rounded-full shadow-sm font-semibold text-gray-700">📍 3 Localizações</span>
            <span className="bg-white border border-gray-100 px-4 py-2 rounded-full shadow-sm font-semibold text-gray-700">⭐ Mais de 25 avaliações</span>
            <span className="bg-white border border-gray-100 px-4 py-2 rounded-full shadow-sm font-semibold text-gray-700">🏆 5.0 estrelas no Google</span>
          </div>
        </div>
      </div>
    </section>
  );
};
